// import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'

const BooleanField = props => {
  const { source, record, whenTrue, whenFalse, equals, notEquals, noUndefines, compare } = props
  let bool
  // Generate comparison
  if (compare) {
    bool = compare(record)
  } else {
    const value = get(record, source)
    if (equals !== undefined) {
      bool = value === equals
    } else if (notEquals !== undefined) {
      if (noUndefines !== undefined && noUndefines) {
        bool = value !== undefined && value !== notEquals
      } else {
        bool = value !== notEquals
      }
    } else {
      bool = !!value
    }
  }
  return bool ? whenTrue : whenFalse
}

BooleanField.defaultProps = {
  record: {},
  whenTrue: null,
  whenFalse: null,
}

BooleanField.propTypes = {
  record: PropTypes.object,
  compare: PropTypes.func,
  noUndefines: PropTypes.any,
  whenTrue: PropTypes.any,
  whenFalse: PropTypes.any,
  equals: PropTypes.any,
}

export default BooleanField



// WEBPACK FOOTER //
// ./ui/Data/BooleanField.js